module.exports = __webpack_public_path__ + "static/media/FRAX-USDC.e14771cb.png";